import { clickType } from "@/types/generalTypes";
import React from "react";

function CloseBasketIcon({ className, onClick }: clickType) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.56067 0.43934C1.97487 -0.146447 1.02513 -0.146447 0.43934 0.43934C-0.146447 1.02513 -0.146447 1.97487 0.43934 2.56067L8.3787 10.5L0.43934 18.4394C-0.146447 19.0251 -0.146447 19.9749 0.43934 20.5607C1.02513 21.1464 1.97487 21.1464 2.56067 20.5607L10.5 12.6213L18.4394 20.5607C19.0251 21.1464 19.9749 21.1464 20.5607 20.5607C21.1464 19.9749 21.1464 19.0251 20.5607 18.4394L12.6213 10.5L20.5607 2.56067C21.1464 1.97487 21.1464 1.02513 20.5607 0.43934C19.9749 -0.146447 19.0251 -0.146447 18.4394 0.43934L10.5 8.3787L2.56067 0.43934Z"
        fill="#252525"
      />
    </svg>
  );
}

export default CloseBasketIcon;
